import { createReducer, on, Action } from '@ngrx/store';
import * as actions from './available-pickups.actions';

const initialState: OLO.State.AvailablePickup[] = [];

export const availablePickupsReducerFn = createReducer(
    initialState,
    on(actions.AvailablePickupsReset, () => []),
    on(actions.AvailablePickupsCalculateRequest, (state, { locationNo, orderTypeId }) => {
        const foundObj = state.find((obj) => obj.locationNo === locationNo);

        if (!foundObj) {
            return [
                ...state,
                {
                    locationNo,
                    orderTypeId,
                    calculatedDate: null,
                    isCalculating: true,
                    hasFailed: false,
                    hasSucceeded: false,
                    data: null,
                },
            ];
        }

        return state.map((obj) => {
            if (obj.locationNo === locationNo) {
                return {
                    ...obj,
                    orderTypeId: orderTypeId,
                    isCalculating: true,
                    hasFailed: false,
                    hasSucceeded: false,
                };
            }

            return obj;
        });
    }),
    on(actions.AvailablePickupsCalculateSuccessRequest, (state, { locationNo, orderTypeId, payload }) =>
        state.map((obj) => {
            if (obj.locationNo === locationNo) {
                return {
                    ...obj,
                    orderTypeId,
                    isCalculating: false,
                    hasFailed: false,
                    hasSucceeded: true,
                    data: payload,
                    calculatedDate: new Date().getTime(),
                };
            }

            return obj;
        }),
    ),
    on(actions.AvailablePickupsCalculateErrorRequest, (state, { locationNo, orderTypeId }) =>
        state.map((obj) => {
            if (obj.locationNo === locationNo) {
                return {
                    ...obj,
                    orderTypeId,
                    isCalculating: false,
                    hasFailed: true,
                    hasSucceeded: false,
                };
            }

            return obj;
        }),
    ),
);

export function availablePickupsReducer(state: OLO.State.AvailablePickup[] | undefined, action: Action) {
    return availablePickupsReducerFn(state, action);
}
